import PropTypes from "prop-types";

function TextThemeBarChart({ data, noData }) {
    if (noData) {
        return (
            <div className="tta-no-data color-black">
                <strong>No Sufficient Data Available</strong>
            </div>
        );
    }

    const max = Math.max(...data.map((theme) => theme.frequency), 1);
    const min = Math.min(...data.map((theme) => theme.frequency), 0);
    const isScrollable = data.length > 3;

    return (
        <div className={isScrollable ? "tta-bar-chart scrollable" : "tta-bar-chart"}>
            <div className="tta-bar-list">
                {data.map((theme) => (
                    <div
                        className="tta-bar-row"
                        key={theme.name}
                    >
                        <span className="tta-bar-label color-black">{theme.name}</span>
                        <span className="tta-bar-track">
                            <span
                                className="tta-bar liner-light-blue-background"
                                style={{ "--bar-width": `${max === min ? 35 : 10 + ((theme.frequency - min) / (max - min)) * 80}%` }}
                            />
                        </span>
                        <span className="tta-bar-value color-blue">{theme.frequency}</span>
                    </div>
                ))}
            </div>
            <span className="tta-chart-footnote color-black">Number = Frequency of the themes</span>
        </div>
    );
}

TextThemeBarChart.propTypes = {
    data: PropTypes.array,
    noData: PropTypes.bool,
};

export default TextThemeBarChart;
